import React from 'react';
import { SYSTEM_ICON_SIZES } from '../../constants';
import { getStrokeColor } from '../../utils';
import type { SystemIconType } from '../../types';

const StarHalfIcon = ({ size = 'sm', color = 'currentColor' }: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      stroke={getStrokeColor(color)}
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.36 1.93a.717.717 0 0 1 1.28 0l1.568 3.078c.104.205.3.347.526.383l3.41.543c.579.092.81.8.396 1.215l-2.442 2.448a.72.72 0 0 0-.2.618l.538 3.417a.717.717 0 0 1-1.034.75l-3.076-1.567a.72.72 0 0 0-.652 0l-.313.16m0-11.046v11.046m0-11.046-.785 1.54M4.598 14.382V5.497m0 8.885.597-.304m-.597.304a.7.7 0 0 1-.496.059m0-4.226-.538 3.417c-.062.395.2.725.538.809m0-4.226a.72.72 0 0 0-.2-.618m.2.618v4.226m-.2-4.844V5.608m0 3.989-.512-.513m-1.535-3.15a.717.717 0 0 0-.395 1.215l.395.41m0-1.625V7.56m0-1.626.512-.081m2.899-.462a.72.72 0 0 0 .526-.383m-.526.383-.668.106m.668-.106-.07 8.687m.596-9.07.784-1.54m-.784 1.54v8.766m1.569-.799-.708.36M6.576 3.47l.077 9.867m0 0-.861.438m0 0-.597.304m-.597-8.58-.696.11m0 0-.512.082m-.512.081v2.8m0-2.8.512-.081m-.512.081-.511.082m.511 2.718.512.513m-.512-.513-.511-.506m-.512-.505.512.505M3.39 5.69v3.394M2.367 5.853v2.212"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
StarHalfIcon.id = 'StarHalfIcon';
StarHalfIcon.displayName = 'StarHalfIcon';
export default StarHalfIcon;
